import { STRING } from "../../../constants/string";

/**
 * "'Неділя,Понеділок" => ["Неділя", "Понеділок"]
 */
const parseArrayOfString = (data: string): string[] =>
  data.split(STRING.COMMA);

export class PrimengTranslateAdapter {
  static format(data: Record<string, string>): Record<string, string[] | string> {
    try {
      const list = Object.entries(data).map(([key, value]) => [key, parseArrayOfString(value)]);
      return Object.fromEntries(list);
    } catch {
      return {};
    }
  }
}
